<div class="layout">
  <app-header></app-header>
  <main class="content">
    <ng-content></ng-content>
  </main>
  @if (useCompactFooter()) {
    <app-compact-footer></app-compact-footer>
  } @else {
    <app-footer></app-footer>
  }
</div>
